
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as errorHLFY7zwFUrfpprhDfpUcz1_Gwa8d9C_XhlejYbumvDkMeta } from "/opt/buildhome/repo/pages/error.vue?macro=true";
import { default as indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as loginKMdcZdjxVWBby7qzc8iax1m1i6js8gN3t8PvZM_RwR8Meta } from "/opt/buildhome/repo/pages/login.vue?macro=true";
import { default as termsM_RN9_459iuNVtH23UOLrjvoINYU4b2nnq0grhd_RmiYYMeta } from "/opt/buildhome/repo/pages/terms.vue?macro=true";
import { default as cookieshtP6F02lBALtGxPTRKVnvGvawtAS2_45RpkQD0HOTY6WIMeta } from "/opt/buildhome/repo/pages/cookies.vue?macro=true";
import { default as pricingq7hLQznf5sDmVmp1DnapVh77taqjuEWxS1X0_40g810Meta } from "/opt/buildhome/repo/pages/pricing.vue?macro=true";
import { default as privacyArxgULVZ2Zifu3wQfKQ0WvqaXaBxDlpI2F7eal9OET8Meta } from "/opt/buildhome/repo/pages/privacy.vue?macro=true";
import { default as registerI5bGXMcIgYuI09GEDHsdRYBdRTdvAXNx2bsszLTicp0Meta } from "/opt/buildhome/repo/pages/register.vue?macro=true";
import { default as verify_45emailji8bDKYt0hugClQpEWRvEpYdUEwRiXqCe1cjQfKe5OcMeta } from "/opt/buildhome/repo/pages/verify-email.vue?macro=true";
import { default as reset_45password7TTpC6bsKAnTRrn0c2lyZltThWIyP9fDCYnH6eGiD0oMeta } from "/opt/buildhome/repo/pages/reset-password.vue?macro=true";
import { default as forgot_45passwordePKZgRXq0jrO1cJ61G6O25BiZx2cM1j2xdPJj4IzVnsMeta } from "/opt/buildhome/repo/pages/forgot-password.vue?macro=true";
import { default as success_npuXIIbdD9aBHf8QNIGuzwicqKKB_45kA6_EujlGqonMMeta } from "/opt/buildhome/repo/pages/payment/success.vue?macro=true";
import { default as cancelledWxJ7DKv8bgrUKZyAX4QGJWyo3VTamfx0E6apYaI9l0MMeta } from "/opt/buildhome/repo/pages/payment/cancelled.vue?macro=true";
import { default as provider_45callbackd0NSnmatVunEgbhumHlQmgEJRS0bURmsxbiYY132SqAMeta } from "/opt/buildhome/repo/pages/provider-callback.vue?macro=true";
import { default as index76iE9Y4Jp9VTE4EV_CcD4daXx42K5zzHTatnEwOMCXUMeta } from "/opt/buildhome/repo/pages/[profession]/index.vue?macro=true";
import { default as update_45verify_45emailhWw4gctYOP9n2ZXjwhbJ4tGznHyrxxFhK3F4Fi4drXwMeta } from "/opt/buildhome/repo/pages/update-verify-email.vue?macro=true";
import { default as _91publicId_93uIT5BwrLsBUNobnAm0EM_45YS__nYHElvBUizL9tBLLPEMeta } from "/opt/buildhome/repo/pages/chat/share/[publicId].vue?macro=true";
import { default as indexuTmKXyGtNa9UGnX5Pbut81O3Vt8jaXEsuvFKbyGuAZsMeta } from "/opt/buildhome/repo/pages/chat/[profession]/index.vue?macro=true";
import { default as indexkyIdFgF_Y0ZGgCUpE1P4xNS_J3WDZ8VEZNxl7BiQc70Meta } from "/opt/buildhome/repo/pages/[profession]/[country]/index.vue?macro=true";
import { default as _91conversationId_93LwaszpFcRJS5JhrG_45GWI4bDyCzfVJ2MvHTA3d27E7RkMeta } from "/opt/buildhome/repo/pages/chat/[profession]/[conversationId].vue?macro=true";
import { default as indexgxHxzTa1fEiLRfOrEHc27ARgAuGpIVXZ1rVg_45if9OgsMeta } from "/opt/buildhome/repo/pages/chat/[profession]/[specialization]/index.vue?macro=true";
import { default as _91conversationId_937Mz_SfLLvTGeqHR9BWgfygct_45xrlzVt119_45wlpOpVOEMeta } from "/opt/buildhome/repo/pages/chat/[profession]/[specialization]/[conversationId].vue?macro=true";
import { default as component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJoMeta } from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJo } from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "error___en",
    path: "/error",
    component: () => import("/opt/buildhome/repo/pages/error.vue")
  },
  {
    name: "error___tr",
    path: "/tr/hata",
    component: () => import("/opt/buildhome/repo/pages/error.vue")
  },
  {
    name: "error___ar",
    path: "/ar/%D8%AE%D8%B7%D8%A3",
    component: () => import("/opt/buildhome/repo/pages/error.vue")
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "index___tr",
    path: "/tr",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "index___ar",
    path: "/ar",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "login___en",
    path: "/login",
    meta: loginKMdcZdjxVWBby7qzc8iax1m1i6js8gN3t8PvZM_RwR8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/login.vue")
  },
  {
    name: "login___tr",
    path: "/tr/giris",
    meta: loginKMdcZdjxVWBby7qzc8iax1m1i6js8gN3t8PvZM_RwR8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/login.vue")
  },
  {
    name: "login___ar",
    path: "/ar/%D8%AA%D8%B3%D8%AC%D9%8A%D9%84-%D8%A7%D9%84%D8%AF%D8%AE%D9%88%D9%84",
    meta: loginKMdcZdjxVWBby7qzc8iax1m1i6js8gN3t8PvZM_RwR8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/login.vue")
  },
  {
    name: "terms___en",
    path: "/terms",
    component: () => import("/opt/buildhome/repo/pages/terms.vue")
  },
  {
    name: "terms___tr",
    path: "/tr/kullanim-sartlari",
    component: () => import("/opt/buildhome/repo/pages/terms.vue")
  },
  {
    name: "terms___ar",
    path: "/ar/%D8%A7%D9%84%D8%B4%D8%B1%D9%88%D8%B7-%D9%88-%D8%A7%D9%84%D8%A7%D8%AD%D9%83%D8%A7%D9%85",
    component: () => import("/opt/buildhome/repo/pages/terms.vue")
  },
  {
    name: "cookies___en",
    path: "/cookies",
    component: () => import("/opt/buildhome/repo/pages/cookies.vue")
  },
  {
    name: "cookies___tr",
    path: "/tr/cerezler",
    component: () => import("/opt/buildhome/repo/pages/cookies.vue")
  },
  {
    name: "cookies___ar",
    path: "/ar/%D9%85%D9%84%D9%81%D8%A7%D8%AA-%D8%AA%D8%B9%D8%B1%D9%8A%D9%81-%D8%A7%D9%84%D8%A7%D8%B1%D8%AA%D8%A8%D8%A7%D8%B7",
    component: () => import("/opt/buildhome/repo/pages/cookies.vue")
  },
  {
    name: "pricing___en",
    path: "/pricing",
    component: () => import("/opt/buildhome/repo/pages/pricing.vue")
  },
  {
    name: "pricing___tr",
    path: "/tr/fiyatlandirma",
    component: () => import("/opt/buildhome/repo/pages/pricing.vue")
  },
  {
    name: "pricing___ar",
    path: "/ar/%D8%A7%D9%84%D8%A3%D8%B3%D8%B9%D8%A7%D8%B1",
    component: () => import("/opt/buildhome/repo/pages/pricing.vue")
  },
  {
    name: "privacy___en",
    path: "/privacy",
    component: () => import("/opt/buildhome/repo/pages/privacy.vue")
  },
  {
    name: "privacy___tr",
    path: "/tr/gizlilik-politikasi",
    component: () => import("/opt/buildhome/repo/pages/privacy.vue")
  },
  {
    name: "privacy___ar",
    path: "/ar/%D8%B3%D9%8A%D8%A7%D8%B3%D8%A9-%D8%A7%D9%84%D8%AE%D8%B5%D9%88%D8%B5%D9%8A%D8%A9",
    component: () => import("/opt/buildhome/repo/pages/privacy.vue")
  },
  {
    name: "register___en",
    path: "/register",
    meta: registerI5bGXMcIgYuI09GEDHsdRYBdRTdvAXNx2bsszLTicp0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/register.vue")
  },
  {
    name: "register___tr",
    path: "/tr/kayit",
    meta: registerI5bGXMcIgYuI09GEDHsdRYBdRTdvAXNx2bsszLTicp0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/register.vue")
  },
  {
    name: "register___ar",
    path: "/ar/%D8%AA%D8%B3%D8%AC%D9%8A%D9%84",
    meta: registerI5bGXMcIgYuI09GEDHsdRYBdRTdvAXNx2bsszLTicp0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/register.vue")
  },
  {
    name: "verify-email___en",
    path: "/verify-email",
    component: () => import("/opt/buildhome/repo/pages/verify-email.vue")
  },
  {
    name: "verify-email___tr",
    path: "/tr/email-dogrulama",
    component: () => import("/opt/buildhome/repo/pages/verify-email.vue")
  },
  {
    name: "verify-email___ar",
    path: "/ar/%D8%AA%D8%A3%D9%83%D9%8A%D8%AF-%D8%A7%D9%84%D8%A8%D8%B1%D9%8A%D8%AF-%D8%A7%D9%84%D8%A5%D9%84%D9%83%D8%AA%D8%B1%D9%88%D9%86%D9%8A",
    component: () => import("/opt/buildhome/repo/pages/verify-email.vue")
  },
  {
    name: "reset-password___en",
    path: "/reset-password",
    meta: reset_45password7TTpC6bsKAnTRrn0c2lyZltThWIyP9fDCYnH6eGiD0oMeta || {},
    component: () => import("/opt/buildhome/repo/pages/reset-password.vue")
  },
  {
    name: "reset-password___tr",
    path: "/tr/sifre-sifirlama",
    meta: reset_45password7TTpC6bsKAnTRrn0c2lyZltThWIyP9fDCYnH6eGiD0oMeta || {},
    component: () => import("/opt/buildhome/repo/pages/reset-password.vue")
  },
  {
    name: "reset-password___ar",
    path: "/ar/%D8%A5%D8%B9%D8%A7%D8%AF%D8%A9-%D8%AA%D8%B9%D9%8A%D9%8A%D9%86-%D9%83%D9%84%D9%85%D8%A9-%D8%A7%D9%84%D9%85%D8%B1%D9%88%D8%B1",
    meta: reset_45password7TTpC6bsKAnTRrn0c2lyZltThWIyP9fDCYnH6eGiD0oMeta || {},
    component: () => import("/opt/buildhome/repo/pages/reset-password.vue")
  },
  {
    name: "forgot-password___en",
    path: "/forgot-password",
    meta: forgot_45passwordePKZgRXq0jrO1cJ61G6O25BiZx2cM1j2xdPJj4IzVnsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___tr",
    path: "/tr/sifremi-unuttum",
    meta: forgot_45passwordePKZgRXq0jrO1cJ61G6O25BiZx2cM1j2xdPJj4IzVnsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___ar",
    path: "/ar/%D9%86%D8%B3%D9%8A%D8%AA-%D9%83%D9%84%D9%85%D8%A9-%D8%A7%D9%84%D9%85%D8%B1%D9%88%D8%B1",
    meta: forgot_45passwordePKZgRXq0jrO1cJ61G6O25BiZx2cM1j2xdPJj4IzVnsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/forgot-password.vue")
  },
  {
    name: "payment-success___en",
    path: "/payment/success",
    component: () => import("/opt/buildhome/repo/pages/payment/success.vue")
  },
  {
    name: "payment-success___tr",
    path: "/tr/payment/success",
    component: () => import("/opt/buildhome/repo/pages/payment/success.vue")
  },
  {
    name: "payment-success___ar",
    path: "/ar/payment/success",
    component: () => import("/opt/buildhome/repo/pages/payment/success.vue")
  },
  {
    name: "payment-cancelled___en",
    path: "/payment/cancelled",
    component: () => import("/opt/buildhome/repo/pages/payment/cancelled.vue")
  },
  {
    name: "payment-cancelled___tr",
    path: "/tr/payment/cancelled",
    component: () => import("/opt/buildhome/repo/pages/payment/cancelled.vue")
  },
  {
    name: "payment-cancelled___ar",
    path: "/ar/payment/cancelled",
    component: () => import("/opt/buildhome/repo/pages/payment/cancelled.vue")
  },
  {
    name: "provider-callback___en",
    path: "/provider-callback",
    meta: provider_45callbackd0NSnmatVunEgbhumHlQmgEJRS0bURmsxbiYY132SqAMeta || {},
    component: () => import("/opt/buildhome/repo/pages/provider-callback.vue")
  },
  {
    name: "provider-callback___tr",
    path: "/tr/provider-callback",
    meta: provider_45callbackd0NSnmatVunEgbhumHlQmgEJRS0bURmsxbiYY132SqAMeta || {},
    component: () => import("/opt/buildhome/repo/pages/provider-callback.vue")
  },
  {
    name: "provider-callback___ar",
    path: "/ar/provider-callback",
    meta: provider_45callbackd0NSnmatVunEgbhumHlQmgEJRS0bURmsxbiYY132SqAMeta || {},
    component: () => import("/opt/buildhome/repo/pages/provider-callback.vue")
  },
  {
    name: "profession___en",
    path: "/:profession()",
    meta: index76iE9Y4Jp9VTE4EV_CcD4daXx42K5zzHTatnEwOMCXUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/[profession]/index.vue")
  },
  {
    name: "profession___tr",
    path: "/tr/:profession()",
    meta: index76iE9Y4Jp9VTE4EV_CcD4daXx42K5zzHTatnEwOMCXUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/[profession]/index.vue")
  },
  {
    name: "profession___ar",
    path: "/ar/%D9%85%D9%87%D9%86%D8%A9/:profession()",
    meta: index76iE9Y4Jp9VTE4EV_CcD4daXx42K5zzHTatnEwOMCXUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/[profession]/index.vue")
  },
  {
    name: "update-verify-email___en",
    path: "/update-verify-email",
    component: () => import("/opt/buildhome/repo/pages/update-verify-email.vue")
  },
  {
    name: "update-verify-email___tr",
    path: "/tr/email-guncelleme-dogrulama",
    component: () => import("/opt/buildhome/repo/pages/update-verify-email.vue")
  },
  {
    name: "update-verify-email___ar",
    path: "/ar/%D8%AA%D8%AD%D8%AF%D9%8A%D8%AB-%D8%AA%D8%A3%D9%83%D9%8A%D8%AF-%D8%A7%D9%84%D8%A8%D8%B1%D9%8A%D8%AF-%D8%A7%D9%84%D8%A5%D9%84%D9%83%D8%AA%D8%B1%D9%88%D9%86%D9%8A",
    component: () => import("/opt/buildhome/repo/pages/update-verify-email.vue")
  },
  {
    name: "chat-share-publicId___en",
    path: "/chat/share/:publicId()",
    meta: _91publicId_93uIT5BwrLsBUNobnAm0EM_45YS__nYHElvBUizL9tBLLPEMeta || {},
    component: () => import("/opt/buildhome/repo/pages/chat/share/[publicId].vue")
  },
  {
    name: "chat-share-publicId___tr",
    path: "/tr/sohbet/paylas/:publicId()",
    meta: _91publicId_93uIT5BwrLsBUNobnAm0EM_45YS__nYHElvBUizL9tBLLPEMeta || {},
    component: () => import("/opt/buildhome/repo/pages/chat/share/[publicId].vue")
  },
  {
    name: "chat-share-publicId___ar",
    path: "/ar/%D8%A7%D9%84%D8%AF%D8%B1%D8%AF%D8%B4%D8%A9/%D9%85%D8%B4%D8%A7%D8%B1%D9%83%D8%A9/:publicId()",
    meta: _91publicId_93uIT5BwrLsBUNobnAm0EM_45YS__nYHElvBUizL9tBLLPEMeta || {},
    component: () => import("/opt/buildhome/repo/pages/chat/share/[publicId].vue")
  },
  {
    name: "chat-profession___en",
    path: "/chat/:profession()",
    meta: indexuTmKXyGtNa9UGnX5Pbut81O3Vt8jaXEsuvFKbyGuAZsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/chat/[profession]/index.vue")
  },
  {
    name: "chat-profession___tr",
    path: "/tr/sohbet/:profession()",
    meta: indexuTmKXyGtNa9UGnX5Pbut81O3Vt8jaXEsuvFKbyGuAZsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/chat/[profession]/index.vue")
  },
  {
    name: "chat-profession___ar",
    path: "/ar/%D8%A7%D9%84%D8%AF%D8%B1%D8%AF%D8%B4%D8%A9/:profession()",
    meta: indexuTmKXyGtNa9UGnX5Pbut81O3Vt8jaXEsuvFKbyGuAZsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/chat/[profession]/index.vue")
  },
  {
    name: "profession-country___en",
    path: "/:profession()/:country()",
    meta: indexkyIdFgF_Y0ZGgCUpE1P4xNS_J3WDZ8VEZNxl7BiQc70Meta || {},
    component: () => import("/opt/buildhome/repo/pages/[profession]/[country]/index.vue")
  },
  {
    name: "profession-country___tr",
    path: "/tr/:profession()/:country()",
    meta: indexkyIdFgF_Y0ZGgCUpE1P4xNS_J3WDZ8VEZNxl7BiQc70Meta || {},
    component: () => import("/opt/buildhome/repo/pages/[profession]/[country]/index.vue")
  },
  {
    name: "profession-country___ar",
    path: "/ar/%D9%85%D9%87%D9%86%D8%A9/:profession()/:country()",
    meta: indexkyIdFgF_Y0ZGgCUpE1P4xNS_J3WDZ8VEZNxl7BiQc70Meta || {},
    component: () => import("/opt/buildhome/repo/pages/[profession]/[country]/index.vue")
  },
  {
    name: "chat-profession-conversationId___en",
    path: "/chat/:profession()/:conversationId()",
    meta: _91conversationId_93LwaszpFcRJS5JhrG_45GWI4bDyCzfVJ2MvHTA3d27E7RkMeta || {},
    component: () => import("/opt/buildhome/repo/pages/chat/[profession]/[conversationId].vue")
  },
  {
    name: "chat-profession-conversationId___tr",
    path: "/tr/sohbet/:profession()/:conversationId()",
    meta: _91conversationId_93LwaszpFcRJS5JhrG_45GWI4bDyCzfVJ2MvHTA3d27E7RkMeta || {},
    component: () => import("/opt/buildhome/repo/pages/chat/[profession]/[conversationId].vue")
  },
  {
    name: "chat-profession-conversationId___ar",
    path: "/ar/%D8%A7%D9%84%D8%AF%D8%B1%D8%AF%D8%B4%D8%A9/:profession()/:conversationId()",
    meta: _91conversationId_93LwaszpFcRJS5JhrG_45GWI4bDyCzfVJ2MvHTA3d27E7RkMeta || {},
    component: () => import("/opt/buildhome/repo/pages/chat/[profession]/[conversationId].vue")
  },
  {
    name: "chat-profession-specialization___en",
    path: "/chat/:profession()/:specialization()",
    meta: indexgxHxzTa1fEiLRfOrEHc27ARgAuGpIVXZ1rVg_45if9OgsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/chat/[profession]/[specialization]/index.vue")
  },
  {
    name: "chat-profession-specialization___tr",
    path: "/tr/chat/:profession()/:specialization()",
    meta: indexgxHxzTa1fEiLRfOrEHc27ARgAuGpIVXZ1rVg_45if9OgsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/chat/[profession]/[specialization]/index.vue")
  },
  {
    name: "chat-profession-specialization___ar",
    path: "/ar/chat/:profession()/:specialization()",
    meta: indexgxHxzTa1fEiLRfOrEHc27ARgAuGpIVXZ1rVg_45if9OgsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/chat/[profession]/[specialization]/index.vue")
  },
  {
    name: "chat-profession-specialization-conversationId___en",
    path: "/chat/:profession()/:specialization()/:conversationId()",
    meta: _91conversationId_937Mz_SfLLvTGeqHR9BWgfygct_45xrlzVt119_45wlpOpVOEMeta || {},
    component: () => import("/opt/buildhome/repo/pages/chat/[profession]/[specialization]/[conversationId].vue")
  },
  {
    name: "chat-profession-specialization-conversationId___tr",
    path: "/tr/chat/:profession()/:specialization()/:conversationId()",
    meta: _91conversationId_937Mz_SfLLvTGeqHR9BWgfygct_45xrlzVt119_45wlpOpVOEMeta || {},
    component: () => import("/opt/buildhome/repo/pages/chat/[profession]/[specialization]/[conversationId].vue")
  },
  {
    name: "chat-profession-specialization-conversationId___ar",
    path: "/ar/chat/:profession()/:specialization()/:conversationId()",
    meta: _91conversationId_937Mz_SfLLvTGeqHR9BWgfygct_45xrlzVt119_45wlpOpVOEMeta || {},
    component: () => import("/opt/buildhome/repo/pages/chat/[profession]/[specialization]/[conversationId].vue")
  },
  {
    name: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJoMeta?.name,
    path: "/sitemap.xml",
    component: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJo
  },
  {
    name: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJoMeta?.name,
    path: "/tr/sitemap.xml",
    component: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJo
  },
  {
    name: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJoMeta?.name,
    path: "/ar/sitemap.xml",
    component: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJo
  }
]